@let isEditingParams =
  recordsEc.plugins.currentListPlugin.feature.selectors.isEditingParams.asSignal();

<atn-ds-page>
  <atn-ds-table
    class="atn-space-records-list"
    [config]="tableConfig"
  >
    <div
      class="atn-space-records-list__actions"
      customTools
    >
      <i
        #blockCodingOverlayTrigger
        class="atn-icon atn-run atn-blue atn-space-records-list__action-icon"
        [class.atn-space-records-list__icon--disabled]="!canBlockCodeSg()"
        [atnDsTooltip]="blockCodingTooltipSg()"
        atnDsTooltipPosition="above"
        [attr.aria-disabled]="!canBlockCodeSg()"
        (click)="canBlockCodeSg() && presentBlockCodingSg.set(true)"
      ></i>
      <atn-space-records-block-coding
        [origin]="blockCodingOverlayTrigger"
        [(presentOverlay)]="presentBlockCodingSg"
        (optionSelected)="blockCodingOptionSelectedHandler($event)"
      />
      <i
        class="atn-icon atn-cluster-add atn-space-records-list__action-icon"
        [class.atn-space-records-list__icon--disabled]="!canAssignClusterSg()"
        [atnDsTooltip]="clusterAssignmentTooltipSg()"
        atnDsTooltipPosition="above"
        [attr.aria-disabled]="!canAssignClusterSg()"
        (click)="clusterAssignmentClickHandler()"
      ></i>
      <i
        class="atn-icon atn-funnel atn-blue atn-space-records-list__action-icon"
        [class.atn-space-records-list__icon-with-info]="hasAppliedParamsSg()"
        (click)="filtersClickHandler()"
      ></i>
    </div>
  </atn-ds-table>
</atn-ds-page>

@if (isEditingParams) {
  <atn-space-record-filters />
}

@if (clusterAssignmentPlugin.selectors.isAssigningCluster.asSignal()) {
  <atn-space-cluster-assignment-modal [isClusterRequired]="true" />
}

@if (bulkCommentPlugin.selectors.isUpdating.asSignal()) {
  <atn-space-bulk-comment-modal />
}

@let isCreatingEmployee =
  employeesEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let isBulkUpdatingResponsiblePersons =
  bulkResponsiblePersonsPlugin.selectors.isUpdating.asSignal();

@if (isBulkUpdatingResponsiblePersons && !isCreatingEmployee) {
  <atn-space-bulk-responsible-persons-modal />
}

@if (isBulkUpdatingResponsiblePersons && isCreatingEmployee) {
  <atn-space-modal-create-employee-form />
}

@if (bulkFunctionalUsagePlugin.selectors.isUpdating.asSignal()) {
  <atn-space-bulk-functional-usage-modal />
}
